import request from 'superagent'
import types from '../types'
import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`
if (api_port === '') {
  apiUrl = `${protocol}//${hostname}/api`
}

const getApplicationWelcomeAlertRequested = () => ({
  type: types.GET_APPLICATION_WELCOME_ALERT_REQUESTED,
  payload: null
})

const getApplicationWelcomeAlertFulfilled = (data: any) => ({
  type: types.GET_APPLICATION_WELCOME_ALERT_FULFILLED,
  payload: data
})

const getApplicationWelcomeAlertRejected = (error: any) => ({
  type: types.GET_APPLICATION_WELCOME_ALERT_REJECTED,
  payload: error
})

export const getApplicationWelcomeAlert = (token: string) => {
  return (dispatch: any) => {
    dispatch(getApplicationWelcomeAlertRequested())
    request
      .get(`${apiUrl}/applicationWelcomeAlert`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .then((response) => {
        dispatch(getApplicationWelcomeAlertFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getApplicationWelcomeAlertRejected(error))
      })
  }
}